import React from 'react';

export default function ProjectCardLoader() {
  return (
    <div className='border border-gray border-opacity-10 shadow-lg rounded-xl p-4 bg-white h-80 select-none animate-pulse'>
      <div className='flex justify-between'>
        <div className='flex space-x-2 items-center'>
          <div className='w-10 h-10 rounded-full bg-slate-200'></div>
          <div className='w-28 h-5  rounded-md bg-slate-200'></div>
        </div>
        <div className='flex space-x-2 items-center'>
          <div className='w-12 h-5  rounded-md bg-slate-200'></div>
          <div className='w-5 h-5  bg-slate-200'></div>
          <div className='w-5 h-5   bg-slate-200'></div>
        </div>
      </div>
      <div className='h-16 mt-5 bg-slate-200 rounded-md'></div>
      <div className='h-7 mt-5 bg-slate-200 rounded-md'></div>
      <div className='h-7 mt-5 bg-slate-200 rounded-md'></div>
      <div className='flex space-x-2 items-center mt-8'>
        <div className='w-10 h-10 bg-slate-200 rounded-full'></div>
        <div>
          <div className='w-28 h-5 mb-1.5 bg-slate-200 rounded-md'></div>
          <div className='w-28 h-3  bg-slate-200 rounded-md'></div>
        </div>
      </div>
    </div>
  );
}
